import { render, staticRenderFns } from "./TipoMandatoForm.vue?vue&type=template&id=1dd32b2e&scoped=true&"
import script from "./TipoMandatoForm.vue?vue&type=script&lang=js&"
export * from "./TipoMandatoForm.vue?vue&type=script&lang=js&"
import style0 from "./TipoMandatoForm.vue?vue&type=style&index=0&id=1dd32b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd32b2e",
  null
  
)

export default component.exports